import { ENV } from '@src/configs';

// TODO: Move this NAPAS bank list to shared lib
const ALL_NAPAS_BANKS = [
  {
    code: 'DPP',
    shortName: 'DPP',
    englishName: 'Sandbox DPP',
    vietnameseName: 'Sandbox DPP',
    isSandbox: true,
  },
  {
    code: 'ABB',
    shortName: 'abbank',
    commonName: 'ABBank',
    englishName: 'An Binh Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP An Bình',
  },
  {
    code: 'ACB',
    shortName: 'acb',
    commonName: 'ACB',
    englishName:
      'Joint Stock Commercial Bank for Investment and Development of Vietnam',
    vietnameseName: 'Ngân hàng TMCP Á Châu',
  },
  {
    code: 'BIDV',
    shortName: 'bidv',
    commonName: 'BIDV',
    englishName: 'Bank for Investment and Development of Vietnam',
    vietnameseName: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam',
  },
  {
    code: 'BAB',
    shortName: 'bacabank',
    commonName: 'Bac A Bank',
    englishName: 'Bac A Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Bắc Á',
  },
  {
    code: 'BVB',
    shortName: 'baovietbank',
    commonName: 'BaoViet Bank',
    englishName: 'Bao Viet Joint Stock Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Bảo Việt',
  },
  {
    code: 'CTG',
    shortName: 'vietinbank',
    commonName: 'VietinBank',
    englishName: 'Vietnam Joint Stock Commercial Bank for Industry and Trade',
    vietnameseName: 'Ngân hàng TMCP Công Thương Việt Nam',
  },
  {
    code: 'EIB',
    shortName: 'eximbank',
    commonName: 'Eximbank',
    englishName: 'Vietnam Export Import Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Xuất nhập khẩu Việt Nam',
  },
  {
    code: 'GPB',
    shortName: 'gpbank',
    commonName: 'GPBank',
    englishName: 'Global Petro Sole Member Limited Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Dầu khí toàn cầu',
  },
  {
    code: 'HDB',
    shortName: 'hdbank',
    commonName: 'HDBank',
    englishName: 'Ho Chi Minh City Development Joint Stock Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Phát triển TP. HCM',
  },
  {
    code: 'IVB',
    shortName: 'indovinabank',
    commonName: 'Indovina Bank',
    englishName: 'Indovina Bank Limited',
    vietnameseName: 'Ngân hàng TNHH Indovina',
  },
  {
    code: 'KLB',
    shortName: 'kienlongbank',
    commonName: 'Kienlongbank',
    englishName: 'Kien Long Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Kiên Long',
  },
  {
    code: 'LPB',
    shortName: 'lpbank',
    commonName: 'LPBank',
    englishName: 'Fortune Vietnam Joint Stock Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Lộc Phát Việt Nam',
  },
  {
    code: 'MB',
    shortName: 'mbbank',
    commonName: 'MBBank',
    englishName: 'Military Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Quân đội',
  },
  {
    code: 'MSB',
    shortName: 'msb',
    commonName: 'MSB',
    englishName: 'Maritime Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Hàng hải Việt Nam',
  },
  {
    code: 'MBV',
    shortName: 'mbv',
    commonName: 'Modern Bank',
    englishName: 'Modern Bank of Vietnam Limited',
    vietnameseName: 'Ngân hàng TNHH Một thành viên Việt Nam Hiện Đại',
  },
  {
    code: 'NAB',
    shortName: 'namabank',
    commonName: 'Nam A Bank',
    englishName: 'Nam A Bank Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Nam Á',
  },
  {
    code: 'NVB',
    shortName: 'ncb',
    commonName: 'NCB',
    englishName: 'National Citizen Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Quốc Dân',
  },
  {
    code: 'OCB',
    shortName: 'ocb',
    commonName: 'OCB',
    englishName: 'Orient Commercial Bank JSC',
    vietnameseName: 'Ngân hàng TMCP Phương Đông',
  },
  {
    code: 'OJB',
    shortName: 'oceanbank',
    commonName: 'OceanBank',
    englishName: 'Ocean Commercial One Member Limited Liability Bank',
    vietnameseName: 'Ngân hàng Thương mại TNHH Một Thành Viên Đại Dương',
  },
  {
    code: 'PBVN',
    shortName: 'publicbank',
    commonName: 'Public Bank',
    englishName: 'Public Bank Vietnam Limited',
    vietnameseName: 'Ngân hàng TNHH MTV Public Việt Nam',
  },
  {
    code: 'PGB',
    shortName: 'pgbank',
    commonName: 'PGBank',
    englishName: 'Prosperity and Growth Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Thịnh Vượng và Phát triển',
  },
  {
    code: 'PVCB',
    shortName: 'pvcombank',
    commonName: 'PVcomBank',
    englishName: 'Vietnam Public Joint Stock Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Đại Chúng Việt Nam',
  },
  {
    code: 'SCB',
    shortName: 'scb',
    commonName: 'SCB',
    englishName: 'Sai Gon Joint Stock Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Sài Gòn',
  },
  {
    code: 'SEAB',
    shortName: 'seabank',
    commonName: 'SeABank',
    englishName: 'Southeast Asia Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Đông Nam Á',
  },
  {
    code: 'SHB',
    shortName: 'shb',
    commonName: 'SHB',
    englishName: 'Saigon-Hanoi Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Sài Gòn - Hà Nội',
  },
  {
    code: 'SGB',
    shortName: 'saigonbank',
    commonName: 'Saigonbank',
    englishName: 'Saigon Bank For Industry And Trade',
    vietnameseName: 'Ngân hàng TMCP Sài Gòn Công Thương',
  },
  {
    code: 'STB',
    shortName: 'sacombank',
    commonName: 'Sacombank',
    englishName: 'Saigon Thuong Tin Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Sài Gòn Thương Tín',
  },
  {
    code: 'SVB',
    shortName: 'shinhanbank',
    commonName: 'Shinhan Bank',
    englishName: 'Shinhan Bank Vietnam Limited',
    vietnameseName: 'Ngân hàng TNHH MTV Shinhan Việt Nam',
  },
  {
    code: 'TCB',
    shortName: 'techcombank',
    commonName: 'Techcombank',
    englishName: 'Viet Nam Technological and Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Kỹ Thương Việt Nam',
  },
  {
    code: 'TPB',
    shortName: 'tpbank',
    commonName: 'TPBank',
    englishName: 'Tien Phong Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Tiên Phong',
  },
  {
    code: 'UOB',
    shortName: 'uob',
    commonName: 'UOB',
    englishName: 'United Overseas Bank (Vietnam) Limited',
    vietnameseName:
      'Ngân hàng TNHH Một Thành Viên United Overseas Bank (Việt Nam)',
  },
  {
    code: 'VAB',
    shortName: 'vietabank',
    commonName: 'VietA Bank',
    englishName: 'VietNam-Asia Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Việt Á',
  },
  {
    code: 'VARB',
    shortName: 'agribank',
    commonName: 'Agribank',
    englishName: 'Vietnam Bank for Agriculture and Rural Development',
    vietnameseName: 'Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam',
  },
  {
    code: 'VB',
    shortName: 'vietbank',
    commonName: 'Vietbank',
    englishName: 'Vietnam Thuong Tin Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Việt Nam Thương Tín',
  },
  {
    code: 'VCB',
    shortName: 'vietcombank',
    commonName: 'Vietcombank',
    englishName: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam',
    vietnameseName: 'Ngân hàng TMCP Ngoại Thương Việt Nam',
  },
  {
    code: 'VCCB',
    shortName: 'vietcapitalbank',
    commonName: 'BVBank',
    englishName: 'Viet Capital Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Bản Việt',
  },
  {
    code: 'VIB',
    shortName: 'vib',
    commonName: 'VIB',
    englishName: 'Vietnam International Commercial Joint Stock Bank',
    vietnameseName: 'Ngân hàng TMCP Quốc tế Việt Nam',
  },
  {
    code: 'VPB',
    shortName: 'vpbank',
    commonName: 'VPBank',
    englishName: 'Vietnam Prosperity Joint Stock Commercial Bank',
    vietnameseName: 'Ngân hàng TMCP Việt Nam Thịnh vượng',
  },
  {
    code: 'VRB',
    shortName: 'vrbank',
    commonName: 'VRB',
    englishName: 'Vietnam - Russia Joint Venture Bank',
    vietnameseName: 'Ngân hàng Liên doanh Việt - Nga',
  },
  {
    code: 'WOO',
    shortName: 'wooribank',
    commonName: 'Woori Bank',
    englishName: 'Woori Bank Vietnam Limited',
    vietnameseName: 'Ngân hàng TNHH MTV Woori Việt Nam',
  },
  {
    code: 'CFC',
    shortName: 'vietcredit',
    commonName: 'VietCredit',
    englishName: 'VietCredit Finance Joint Stock Company',
    vietnameseName: 'Công ty Tài chính Cổ phần Tín Việt',
  },
  {
    code: 'MAFC',
    shortName: 'miraeassetfinance',
    commonName: 'Mirae Asset',
    englishName: 'Mirae Asset Finance Company (Vietnam) Limited',
    vietnameseName: 'Công ty Tài chính TNHH MTV Mirae Asset (Việt Nam)',
  },
  {
    code: 'KEBHANAHN',
    shortName: 'kebhana_hanoi',
    commonName: 'KEB Hana Bank (HN)',
    englishName: 'KEB Hana Bank - Hanoi Branch',
    vietnameseName: 'Ngân hàng KEB Hana - Chi nhánh Hà Nội',
  },
  {
    code: 'KEBHANAHCM',
    shortName: 'kebhana_hcm',
    commonName: 'KEB Hana Bank (HCM)',
    englishName: 'KEB Hana Bank - Ho Chi Minh City Branch',
    vietnameseName: 'Ngân hàng KEB Hana - Chi nhánh Hồ Chí Minh',
  },
  {
    code: 'MCREDIT',
    shortName: 'mcredit',
    commonName: 'Mcredit',
    englishName: 'MB SHINSEI Finance Limited Liability Company',
    vietnameseName: 'Công ty Tài chính TNHH MB Shinsei',
  },
];

const canShowNapasBank = (bank) => {
  if (!bank.isSandbox) return true;

  return ENV !== 'prod';
};

const NAPAS_BANKS = ALL_NAPAS_BANKS.filter(canShowNapasBank);

const NAPAS_BANK_SEARCH_FIELDS = [
  'label',
  'value',
  'code',
  'shortName',
  'commonName',
  'vietnameseName',
  'englishName',
];

const getNapasBankOptions = (language) => {
  const isVietnamese = language === 'vi';

  return NAPAS_BANKS.map((bank) => {
    const label = `${bank.commonName || bank.shortName} - ${
      isVietnamese ? bank.vietnameseName : bank.englishName
    }`;

    return {
      ...bank,
      label,
      value: bank.code,
    };
  });
};

const NAPAS_BANK_OPTIONS = getNapasBankOptions('vi');

export {
  NAPAS_BANKS,
  NAPAS_BANK_OPTIONS,
  NAPAS_BANK_SEARCH_FIELDS,
  getNapasBankOptions,
};
